import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default function init() {
  tippy('[data-tippy-content]');
}
